"use client";

import { useGuestUid } from "@/hooks/useGuestUid";

export default function GuestUidProvider({ children }) {
  useGuestUid();
  return <>{children}</>;
}
